import {useQueryResultTopReferer} from '../../hook/useQuery'
import {formatShortenNumber} from "../../utils/format";
import {useTranslation} from '../../hook/useTranslation';
import {TopList, TopListItem} from "@octavius-rocks/ui";

const TopRefererWidget = ()=>{
    const i18n = {
        ...useTranslation("referer"),
        ...useTranslation("base")
    }
    const {value = []} = useQueryResultTopReferer()
    if(!Array.isArray(value)) return null;
    return <TopList>
        {value.map(({referer_domain, hits})=> <TopListItem
            key={referer_domain}
            text={(referer_domain !== null)? referer_domain : i18n.direct_call}
            description={`${formatShortenNumber(hits)} ${i18n.hits}`}
            url={"https://"+referer_domain}
        />)}
    </TopList>
}

export default TopRefererWidget
